import { useQueryClient } from '@tanstack/react-query';
import { CONTENT_LIST_QUERY_KEY } from '../document';
export const BLOCK_LIST_QUERY_KEY = ['research', 'block', 'find'];
function getBlockListQueryKey(content) {
    return [...BLOCK_LIST_QUERY_KEY, content];
}
function getBlockRetrieveQueryKey(id) {
    return ['research', 'block', 'retrieve', id];
}
export function createReportBlockRepository(config) {
    const { repository, client, record: recordRepository, collection: collectionRepository, resource: resourceRepository, } = config;
    return {
        useFind(context, props, options) {
            const queryClient = useQueryClient();
            const prefetch = {
                record: recordRepository.usePrefetchFind(context),
                collection: collectionRepository.usePrefetchRetrieve(context),
                resource: resourceRepository.usePrefetchRetrieve(context),
            };
            const query = repository.useQuery({
                ...options,
                queryKey: getBlockListQueryKey(props.content),
                async queryFn() {
                    const response = await client.user.default.blockList({
                        content: props.content,
                    });
                    await Promise.all(response.data.data.flatMap((block) => {
                        if (block.data.kind === 'database_view') {
                            return [
                                prefetch.record.trigger({
                                    collection: block.data.collection,
                                }),
                                prefetch.collection.trigger({
                                    collectionId: block.data.collection,
                                }),
                            ];
                        }
                        if (block.data.kind === 'resource') {
                            return [
                                prefetch.resource.trigger({
                                    resourceId: block.data.resource,
                                }),
                            ];
                        }
                        return [];
                    }));
                    return response.data.data;
                },
                async onSuccess(data) {
                    for (const block of data) {
                        const queryKey = getBlockRetrieveQueryKey(block.id);
                        queryClient.setQueryData(queryKey, block);
                    }
                    await queryClient.refetchQueries(CONTENT_LIST_QUERY_KEY);
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getBlockRetrieveQueryKey(props.id),
                async queryFn() {
                    const message = `expected block ${props.id} to have been preloaded from useFind`;
                    console.warn(message);
                    // throw new Error(message);
                    const response = await client.user.default.blockRetrieve({
                        blockId: props.id,
                    });
                    return response.data;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=reportBlockRepository.js.map